// components/Header.jsx
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../assets/css/Header.css';
import Logo from '../assets/icons/Logo.jpg';
import ConsultationScheduling from './ConsultationScheduling';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [consultationSuccess, setConsultationSuccess] = useState(false); // Not used - ConsultationScheduling handles success internally
  const location = useLocation();

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const openModal = () => {
    setIsModalOpen(true);
    closeMenu(); // Close mobile menu when opening modal
  };

  const closeModal = () => {
    setIsModalOpen(false);
    // setConsultationSuccess(false); // Not used
  };

  // Handle consultation success (currently handled internally by ConsultationScheduling)
  // const handleConsultationSuccess = () => {
  //   setConsultationSuccess(true);
  //   // You can add a timeout to automatically close the modal after success
  //   setTimeout(() => {
  //     closeModal();
  //   }, 3000);
  // };

  // Handle anchor links on home page
  const handleAnchorClick = (hash, e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    closeMenu();
  };

  return (
    <>
      <header>
        <div className="logo">
          <Link to="/" onClick={closeMenu}>
            <div className="logo-image-container">
              <img src={Logo} alt="BPD Online Corp Logo" className="logo-image" />
            </div>
            <div className="logo-text">
              <span className="logo-bpd">BPD</span>
              <span className="logo-online">ONLINE CORP</span>
            </div>
          </Link>
        </div>
        <nav className={isMenuOpen ? 'nav-open' : ''}>
          <ul>
            <li>
              {location.pathname === '/' ? (
                <a href="#home" onClick={(e) => handleAnchorClick('#home', e)}>Home</a>
              ) : (
                <Link to="/" onClick={closeMenu}>Home</Link>
              )}
            </li>
            <li>
              {location.pathname === '/' ? (
                <a href="#services" onClick={(e) => handleAnchorClick('#services', e)}>Services</a>
              ) : (
                <Link to="/#services" onClick={closeMenu}>Services</Link>
              )}
            </li>
            <li>
              {location.pathname === '/' ? (
                <a href="#why-us" onClick={(e) => handleAnchorClick('#why-us', e)}>Why Choose Us</a>
              ) : (
                <Link to="/#why-us" onClick={closeMenu}>Why Choose Us</Link>
              )}
            </li>
            <li>
              {location.pathname === '/' ? (
                <a href="#about" onClick={(e) => handleAnchorClick('#about', e)}>About</a>
              ) : (
                <Link to="/#about" onClick={closeMenu}>About</Link>
              )}
            </li>
            <li>
              {location.pathname === '/' ? (
                <a href="#contact" onClick={(e) => handleAnchorClick('#contact', e)}>Contact</a>
              ) : (
                <Link to="/#contact" onClick={closeMenu}>Contact</Link>
              )}
            </li>
            <li>
              <Link to="/careers" onClick={closeMenu}>Careers</Link>
            </li>
          </ul>
          <button className="apply-btn" onClick={openModal}>Book Now</button>
        </nav>
        <button 
          className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </header>

      {/* Consultation Scheduling Modal */}
      {isModalOpen && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.6)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div className="modal-content" style={{
            background: 'white',
            padding: '2rem',
            borderRadius: '16px',
            width: '90%',
            maxWidth: '500px',
            maxHeight: '80vh',
            overflowY: 'auto',
            position: 'relative'
          }}>
            <button 
              className="close-button" 
              onClick={closeModal}
              style={{
                position: 'absolute',
                top: '1rem',
                right: '1rem',
                background: 'none',
                border: 'none',
                fontSize: '1.5rem',
                cursor: 'pointer',
                color: '#64748b'
              }}
            >
              ×
            </button>
            <ConsultationScheduling />
          </div>
        </div>
      )}

      {/* Success Message - handled internally by ConsultationScheduling component */}
    </>
  );
};

export default Header;